import { render } from "./ArticleSmallBox.vue?vue&type=template&id=6e668504&scoped=true"
import script from "./ArticleSmallBox.vue?vue&type=script&lang=js"
export * from "./ArticleSmallBox.vue?vue&type=script&lang=js"

import "./ArticleSmallBox.vue?vue&type=style&index=0&id=6e668504&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\User\\OneDrive - Universidad Nacional de Colombia\\Documentos\\Desarrollo\\Tempo\\Front\\Tempo-Front\\tempo-front\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e668504"]])

export default __exports__